// URL Recovery Extension for Deep Linking

import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { useCallback } from 'react';
// Helper to set or delete array parameters
const setArrayParam = (params, key, values) => {
  params.delete(key);
  if (values != null && values.length) {
    values.forEach(value => params.append(key, value));
  }
};

// Helper to build URL params from search filters
const buildUrlParams = filters => {
  const params = new URLSearchParams(window.location.search);
  const query = filters.query,
    tlds = filters.tlds,
    keywords = filters.keywords,
    style = filters.style;
  if (query) {
    params.set('q', query);
  } else if (query === '') {
    params.delete('q');
  }
  setArrayParam(params, 'tlds', tlds);
  setArrayParam(params, 'keywords', keywords);
  if (style) {
    params.set('style', style);
  }
  return params;
};
export const urlRecoveryExtension = createModuleExtension({
  extensionName: 'urlRecovery',
  SDK: {
    hooks: {
      useUrlRecovery: () => useUrlRecovery()
    }
  }
});
export const useUrlRecovery = () => {
  const updateUrl = useCallback(filters => {
    const params = buildUrlParams(filters);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }, []);
  const recoverFromUrl = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get('query') || params.get('q') || params.get('searchText') || '';

    // Clean up legacy param names — canonical is 'q'
    if (params.has('query') || params.has('searchText')) {
      params.delete('query');
      params.delete('searchText');
      if (query) {
        params.set('q', query);
      }
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
    return {
      query,
      tlds: params.getAll('tlds').filter(Boolean),
      keywords: params.getAll('keywords').filter(Boolean),
      style: params.get('style') || ''
    };
  }, []);
  const getUrlState = useCallback(filters => buildUrlParams(filters).toString(), []);
  return {
    updateUrl,
    recoverFromUrl,
    getUrlState
  };
};
//# sourceMappingURL=urlRecoveryExtension.js.map